import React, { useState, useCallback } from 'react';
import ProjectAppDataTableBlock from './ProjectAppDataTableBlock';
import ProjectAppKanbanBlock from './ProjectAppKanbanBlock';
import StackedDataSettings from './StackedDataSettings';
import { ReactComponent as TableIcon } from '../../../icons/table-icon.svg';
import { ReactComponent as KanbanIcon } from '../../../icons/kanban-icon.svg';
import './project-app-stacked-data-block.scss';

interface ProjectAppStackedDataBlockProps {
  blockId: string;
  data: Record<string, unknown>;
}

type ViewTab = 'table' | 'kanban' | 'settings';

const ProjectAppStackedDataBlock: React.FC<ProjectAppStackedDataBlockProps> = ({
  blockId,
  data,
}) => {
  const dataTableId = data.dataTableId as string | undefined;
  const initialDefault = (data.defaultView as 'table' | 'kanban') || 'table';
  const [activeTab, setActiveTab] = useState<ViewTab>(initialDefault);

  const handleSettingsSaved = useCallback((defaultView: 'table' | 'kanban') => {
    setActiveTab(defaultView);
  }, []);

  return (
    <div className='stacked-data-block'>
      <div className='stacked-data-tabs'>
        {initialDefault === 'kanban' ? (
          <>
            <button
              className={`stacked-data-tab${activeTab === 'kanban' ? ' active' : ''}`}
              onClick={() => setActiveTab('kanban')}
            >
              <KanbanIcon /> Board
            </button>
            <button
              className={`stacked-data-tab${activeTab === 'table' ? ' active' : ''}`}
              onClick={() => setActiveTab('table')}
            >
              <TableIcon /> Table
            </button>
          </>
        ) : (
          <>
            <button
              className={`stacked-data-tab${activeTab === 'table' ? ' active' : ''}`}
              onClick={() => setActiveTab('table')}
            >
              <TableIcon /> Table
            </button>
            <button
              className={`stacked-data-tab${activeTab === 'kanban' ? ' active' : ''}`}
              onClick={() => setActiveTab('kanban')}
            >
              <KanbanIcon /> Board
            </button>
          </>
        )}
        <button
          className={`stacked-data-tab stacked-data-tab--edit${activeTab === 'settings' ? ' active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          Edit
        </button>
      </div>

      <div className='stacked-data-content'>
        {activeTab === 'table' && (
          <ProjectAppDataTableBlock blockId={blockId} data={data} embedded />
        )}
        {activeTab === 'kanban' && (
          <ProjectAppKanbanBlock blockId={blockId} data={data} embedded />
        )}
        {activeTab === 'settings' && (
          <StackedDataSettings
            blockId={blockId}
            dataTableId={dataTableId}
            data={data}
            onSaved={handleSettingsSaved}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectAppStackedDataBlock;
